//*******************************************************************************
// 0.0 - GENERAL
//*******************************************************************************

function headerHeight() {
	return $('.header-main').outerHeight();
}

function windowHeight() {
	return $(window).outerHeight();
}



function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}


// FASTCLICK
$(function () {
	// Causes issues with form checkbox for terms (user has to double tap in case fastclick is enabled)
	FastClick.attach(document.body);
});




//*******************************************************************************
// 1.0 - TABS
//*******************************************************************************

$(function () {
    var index = 0;
    var $tabs = $('a.tab');

    $tabs.bind(
        {
            // on keydown,
            // determine which tab to select
            keydown: function (ev) {
                var LEFT_ARROW = 37;
                var UP_ARROW = 38;
                var RIGHT_ARROW = 39;
                var DOWN_ARROW = 40;

                var k = ev.which || ev.keyCode;

                // if the key pressed was an arrow key
                if (k >= LEFT_ARROW && k <= DOWN_ARROW) {
                    // move left one tab for left and up arrows
                    if (k == LEFT_ARROW || k == UP_ARROW) {
                        if (index > 0) {
                            index--;
                        }
                        // unless you are on the first tab,
                        // in which case select the last tab.
                        else {
                            index = $tabs.length - 1;
                        }
                    }

                    // move right one tab for right and down arrows
                    else if (k == RIGHT_ARROW || k == DOWN_ARROW) {
                        if (index < ($tabs.length - 1)) {
                            index++;
                        }
                        // unless you're at the last tab,
                        // in which case select the first one
                        else {
                            index = 0;
                        }
                    }

                    // trigger a click event on the tab to move to
                    $($tabs.get(index)).click();
                    ev.preventDefault();
                }
            },

            // just make the clicked tab the selected one
            click: function (ev) {
                index = $.inArray(this, $tabs.get());
                setFocus();
                ev.preventDefault();
            }
        });

    var setFocus = function () {
        // undo tab control selected state,
        // and make them not selectable with the tab key
        // (all tabs)
        $tabs.attr(
            {
                tabindex: '-1',
                'aria-selected': 'false'
            }).removeClass('selected');

        // hide all tab panels.
        $('.tab-panel').removeClass('current');

        // make the selected tab the selected one, shift focus to it
        $($tabs.get(index)).attr(
            {
                tabindex: '0',
                'aria-selected': 'true'
            }).addClass('selected').focus();

        // handle parent <li> current class (for coloring the tabs)
        $($tabs.get(index)).parent().siblings().removeClass('current');
        $($tabs.get(index)).parent().addClass('current');

        // add a current class also to the tab panel
        // controlled by the clicked tab
        $($($tabs.get(index)).attr('href')).addClass('current');

        $('.gallery-grid').isotope('layout');
    };
});





//*******************************************************************************
// 2.0 - SLICKS
//*******************************************************************************
function lazyLoadGalleryBgImage(a)
{
    if (!a) {
        return;
    }
    const img = a.querySelector('img');
    if (!img) {
        return;
    }
    const imgUrl = img.getAttribute('data-lazy') || img.getAttribute('src');

    a.style = 'background-image:url("'+ imgUrl +'")';
    a.classList.add('shown');
}


function slickInit() {

    const initFirstImages = function (css) {
        $(css +':lt(3)').each(function () {
            lazyLoadGalleryBgImage(this);
        });
    };
    const slickSettings = {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        dots: false,
        arrows: true,
        infinite: false,
        focusOnSelect: false,
        prevArrow: '<div class="nav-arrow : nav-arrow--prev"></div>',
        nextArrow: '<div class="nav-arrow : nav-arrow--next"></div>',
        variableWidth: true,
        responsive: [{
            breakpoint: 767,
            settings: {
                adaptiveHeight: true
            }
        }]
    };
    const slickLazyLoading = function (el) {
        el.on('beforeChange', () => {
            $('.tab-panel.current .gallery-image-slider .gallery-image:not(.shown):lt(2)').each(function () {
                lazyLoadGalleryBgImage(this);
            });
        });
    };
    initFirstImages('.tab-panel.current .gallery-image-slider .gallery-image');
    let gallerySlider = $('.tab-panel.current .gallery-image-slider').slick(slickSettings);
    //on slide change, lazyload next 2 images
    slickLazyLoading(gallerySlider);



    //on year change, destroy slick and make new one
    $('.gallery .tabs-list a').on('click', function () {
        gallerySlider.slick('unslick');
        const newId = this.getAttribute('aria-controls');
        initFirstImages('#'+ newId +' .gallery-image-slider .gallery-image');
        gallerySlider = $('#'+ newId +' .gallery-image-slider').slick(slickSettings);
        slickLazyLoading(gallerySlider);
    });
}





//*******************************************************************************
// 3.0 - READY
//*******************************************************************************
$(document).ready(function () {

	/***
	 * Mobile Menu
	 ***/
	$('.menu-hamburger').on('click', function () {
		$('body').toggleClass('is-open-menu');
		$(this).toggleClass('is-open');
	});

	/***
	 * Speakers list  hover effect
	 ***/
	$('.mod-speakers-image-wrap').mouseenter(function () {
		$(this).addClass('is-hover');
	}).mouseleave(function () {
		$('.mod-speakers-image-wrap').removeClass('is-hover');
	});

	/***
	 * Init Sliders
	 ***/
	slickInit();

    /***
	 * Pager Listener
     ***/

    $('.pagination-link').on('click', function (e) {
    	e.preventDefault();
    	let refresh = false;
    	if($(this).hasClass('pagination-link--prev')) {
            let prev = $(this).closest('.pagination').find('li.is-active').prev();
            if (!prev.hasClass('pagination-prev')) {
                $(this).parent().parent().find('li').removeClass('is-active');
                prev.addClass('is-active');
                refresh = true;
            }
		} else if($(this).hasClass('pagination-link--next')) {
            let next = $(this).closest('.pagination').find('li.is-active').next();
            if (!next.hasClass('pagination-next')) {
                $(this).parent().parent().find('li').removeClass('is-active');
                next.addClass('is-active');
                refresh = true;
			}
        } else {
			$(this).closest('.pagination').find('li').removeClass('is-active');
			$(this).parent().addClass('is-active');
            refresh = true;
        }
        if (refresh) {
			const page = $(this).closest('.pagination').find('li.is-active').find('a').text();
			const folder = $('.tabs-list--square-btn li a.selected').text();
			const pageLimit = $('.gallery').data('onpage');
			const path = $('.gallery').data('path');
			galleryChangePage(path,  folder, pageLimit, page);
        }
    });

    function galleryChangePage(path, folder, pageLimit, page)
	{
        $.ajax({
            url: '/api/v1/folder-images',
            type: 'GET',
            data: {path, folder, pageLimit, page},
            success: function (response) {
                let layout = $(`#${folder} div.gallery-grid`);
                layout.isotope('destroy');
                let html = `<div class="grid-sizer : col-md-4 : col-6"></div>`;
                $.each(response.images, function(index, item) {
                    html += `
						<div class="grid-item : col-md-4 : col-6">
							<a href="${item}" data-fancybox="gallery${folder}" class="gallery-image">
								<img src="${item}" alt="gallery image">
							</a>
						</div>
					`;
                });
                layout.html(html);

                //lazy load all images, then init isotope
                const allImagesFinished = () => {
                    $("#ajaxLoader").hide();
                    initGallery(folder);
                    specto_scroll($('#'+folder).offset().top);
                };
                const allImages = layout[0].getElementsByTagName('img');
                let loadedImages = allImages.length;
                for (var i = 0; i < allImages.length; i++) {
                    if (allImages[i].complete) {
                        loadedImages--;
                    } else {
                        allImages[i].addEventListener('load', function() {
                            loadedImages--;
                            if (loadedImages === 0) {
                                allImagesFinished();
                            }
                        });
                    }
                }
                if (loadedImages === 0) {
                    allImagesFinished();
                } else {
                    $("#ajaxLoader").show();
                }
            }
        });
	}

	/***
	 * Scroll to gallery
	 ***/
	$('.tabs-list--square-btn a').on('click', function () {
		$('html, body').animate({
			scrollTop: $(".sc-gallery--innerpage").offset().top - headerHeight()
		}, 1000);
		$('.pagers').hide();
		$('#pager-'+$(this).attr('aria-controls')).show();
	});

	/***
	 * File upload
	 ***/
	$('.inputfile').each(function () {
		let $input = $(this),
			$label = $(this).parents('.file-upload').find('.file-upload-label'),
			labelVal = $label.html();

		$input.on('change', function (e) {
			let fileName = '';

			if (this.files && this.files.length > 1)
				fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
			else if (e.target.value)
				fileName = e.target.value.split('\\').pop();

			if (fileName)
				$(this).parents('.file-upload').find('.file-upload-name').html(fileName);
			else
				$label.html(labelVal);
		});

		// Firefox bug fix
		$input
			.on('focus', function () { $input.addClass('has-focus'); })
			.on('blur', function () { $input.removeClass('has-focus'); });
	});

	// ##################################################
	// Modal opening & closing
	// ##################################################

	function toggleModal(close) {

		// We open the modal and remember the top position
		if (!close) {
			// var offsetY = window.pageYOffset;
			// $('body').attr('fromTop', offsetY);

			// // Wait for the duration of the 'tmodal' animation ... 500ms
			// setTimeout(function(){
			// 	$('body').addClass('noscroll');
			// 	$('body').css('top', -offsetY + 'px');
			// }, 500);

			$('body').addClass('is-open-modal');

		}
		// Close the modal and scroll to the previous position with no delay
		else {
			//var offsetY = $('body').attr('fromTop');
			//$('body').removeClass('noscroll');
			//$('body').removeAttr('style').removeAttr('fromTop');
			//$('html, body').animate({scrollTop: offsetY}, 0);

			$('body').removeClass('is-open-modal');
			$('.modal.is-open-modal').removeClass('is-open-modal');
		}

	}

	// Modal window
	// Open TERMS modal
	$('.modal-open').click(function (e){
		e.preventDefault();

		var modalToOpen = $(this).attr('rel');

		toggleModal();
		$('div[rel="'+modalToOpen+'"]').addClass('is-open-modal');
		//$('body').addClass('is-open-modal');

	});

	// Close modal
	// $('.modal-close').click(function (){

	// 	toggleModal(close);
	// 	$('body').removeClass('is-open-modal');
	// 	$('.modal.is-open-modal').removeClass('is-open-modal');

	// });


	// Detect all clicks on the document
	document.addEventListener("click", function(event) {

		var box = document.querySelector(".modal.is-open-modal");

		if(box) {

			// If user clicks inside the element, do nothing
			if (event.target.closest(".modal.is-open-modal .modal-main")) return;

			// If user clicks on the modal opener, also do nothing
			if (event.target.closest(".modal-open")) return;

			// If user clicks outside the element, hide it!
			box.classList.remove("is-open-modal");
			toggleModal(close);

		}

	});

    if ($('#countdown-wrapper').length) {
        $('#countdown-wrapper').countdown('2021/09/16 11:00:00', function(event) {
            $('#ct-days').html(event.strftime('%D'));
            $('#ct-hours').html(event.strftime('%H'));
            $('#ct-minutes').html(event.strftime('%M'));
            $('#ct-seconds').html(event.strftime('%S'));
        });
    }
});


//********************************************
// X.0 - WINDOW LOAD
//********************************************
$(window).on('load', function () {

	// Match height added to class equal-height
	$('.equal-height').matchHeight();

	$('.equal-height-inner').matchHeight();

	$('.equal-height-not-by-row').matchHeight({
		byRow: false
	});

    if ($('.gallery-grid').length) {
        initGallery();
    }
	/***
	 * Gallery isotop
	 ***/

});

function initGallery(folder = '')
{
    const isoOptions = {
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
            columnWidth: '.grid-sizer'
        }
    };
    if(folder === '') {
        $('.gallery-grid').isotope(isoOptions);
    } else {
        $(`#${folder} div.gallery-grid`).isotope(isoOptions);
    }

}
